import http from './index'
import QS from 'qs'
/**
 * 托运人申请
 * @param
 */
export function shipperApply(data) {
  data = QS.stringify(data)
  return http({
    url: '/ums/ent/status/2/shipper',
    method: 'POST',
    data
  })
}
/**
 * 托运人重新申请
 * @param
 */
export function shipperApplyUpdate(data) {
  const id = data.entId
  data = QS.stringify(data)
  return http({
    url: `/ums/ent/status/2/shipper/${id}`,
    method: 'PUT',
    data
  })
}
/**
 * 运输公司申请
 * @param
 */
export function carrierApply(data) {
  data = QS.stringify(data)
  return http({
    url: '/ums/ent/status/2/fleet',
    method: 'POST',
    data
  })
}
/**
 * 运输公司重新申请
 * @param
 */
export function carrierApplyUpdate(data) {
  const id = data.entId
  data = QS.stringify(data)
  return http({
    url: `/ums/ent/status/2/fleet/${id}`,
    method: 'PUT',
    data
  })
}
/**
 * 企业详情
 * @param
 */
export function entDetail(query) {
  return http({
    url: `/ums/ent/${query.id}`,
    method: 'GET',
    params: query
  })
}
/**
 * 经纪人申请
 * @param
 */
export function agentApply(data) {
  data = QS.stringify(data)
  return http({
    url: '/ums/agent/status/2',
    method: 'POST',
    data
  })
}
/**
 * 经纪人重新申请
 * @param
 */
export function agentApplyUpdate(data) {
  const userId = data.userId
  data = QS.stringify(data)
  return http({
    url: `/ums/agent/status/1011/${userId}`,
    method: 'PUT',
    data
  })
}
/**
 * 经纪人详情
 * @param
 */
export const  agentDetail = query=> {
  return http({
    url: `/ums/agent`,
    method: 'GET',
    params: query
  })
}
/**
 * ocr营业执照
 * @param
 */
export function ocrBiz(query) {
  return http({
    url: `/identity/ocr/biz`,
    method: 'GET',
    params: query
  })
}
/**
 * ocr身份证
 * @param
 */
export function ocrId(query) {
  return http({
    url: `/identity/ocr/id`,
    method: 'GET',
    params: query,
    headers: { scope: 2 }
  })
}
/**
 * 运输公司认证详情
 * @param
 */
 export function carrierDetail(query) {
  return http({
    url: `/ums/ent/fleet/2_17_0/${query.id}`,
    method: 'GET',
    params: query
  })
}
/**
 * 托运人认证详情
 * @param
 */
 export function shipperDetail(query) {
  return http({
    url: `/ums/ent/shipper/${query.id}`,
    method: 'GET',
    params: query
  })
}
/**
 * 提交认证-托运人（多角色）
 * @param
 */
 export function multipleShipper(data) {
  return http({
    url: '/ums/ent/status/2/multiple/shipper',
    method: 'POST',
    data:QS.stringify(data),
    headers: { scope: 3,scopeId: data.entId}
  })
}
/**
 * 提交认证-车队（多角色）
 * @param
 */
 export function multipleFleet(data) {
  return http({
    url: '/ums/ent/status/2/multiple/fleet',
    method: 'POST',
    data:QS.stringify(data),
    headers: { scope: 3,scopeId: data.entId}
  })
}


// WEBPACK FOOTER //
// ./src/api/auth.js